<template>
  <z-page class="member-list">
    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item" style="width:240px;">
        <div>搜索：</div>
        <div>
          <el-input
            size="mini"
            style="width:200px;"
            v-model="search.text"
            placeholder="关键字搜索"
            suffix-icon="el-icon-search"
          >
            <el-select v-model="search.text_type" slot="prepend" placeholder="请选择">
              <el-option label="账号" :value="1"></el-option>
              <el-option label="企业名称" :value="2"></el-option>
            </el-select>
            <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
          </el-input>
        </div>
      </div>
      <div class="search-item">
        <div>会员等级：</div>
        <div class="long">
          <el-select size="mini" v-model="search.member_level" slot="prepend" placeholder="请选择">
            <el-option label="不限" :value="''"></el-option>
            <el-option label="未付费会员" :value="0"></el-option>
            <el-option label="普通会员" :value="1"></el-option>
            <el-option label="银卡会员" :value="2"></el-option>
            <el-option label="金卡会员" :value="3"></el-option>
            <el-option label="特惠会员" :value="4"></el-option>
            <el-option label="内部会员" :value="5"></el-option>
          </el-select>
        </div>
      </div>
      <div class="search-item">
        <div>产品名称：</div>
        <div class="long">
          <el-select size="mini" v-model="search.productId" slot="prepend" placeholder="请选择">
            <el-option
              v-for="(item,index) in product"
              :key="index"
              :label="item.category_name"
              :value="item.ecsProduct.id"
            >{{item.category_name}}</el-option>
          </el-select>
        </div>
      </div>
      <div class="search-item">
        <div>用户来源：</div>
        <div class="long">
          <el-select size="mini" v-model="search.registerSource" slot="prepend" placeholder="请选择">
            <el-option label="官网" value="1"></el-option>
            <el-option label="其他" value="2"></el-option>
            <el-option label="不限" :value="null"></el-option>
          </el-select>
        </div>
      </div>

      <div class="search-item">
        <div>转化时间：</div>
        <div class="long">
          <el-date-picker
            class="datepicker"
            v-model="search.start_time"
            size="mini"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
            :picker-options="searchPickerOptions"
          ></el-date-picker>-
          <el-date-picker
            class="datepicker"
            v-model="search.end_time"
            size="mini"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
            :picker-options="searchPickerOptions"
          ></el-date-picker>
        </div>
      </div>
      <div @click="searchData" class="search-btn z-btn normal">搜索</div>
      <div @click="clearsearch" style="margin-left:20px;" class="search-btn">清除搜索</div>
    </div>

    <!-- 列表 -->
    <div class="page-list">
      <div class="list-head">
        <div>账号</div>
        <div>企业名称</div>
        <div>所在地区</div>
        <div>联系电话</div>
        <div>会员等级</div>
        <div>授权时间</div>
        <div>转化时间</div>
        <div>用户来源</div>
        <div>客户经理</div>
        <div>操作</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div v-for="(item, index) in data_list" :key="index" class="list-item">
          <div :title="item.account||'--'">{{item.account||'--'}}</div>

          <div>
            <div class="v_tip">
              <div v-tip="item.companyName||'--'" class="content"></div>
            </div>
          </div>
          <div class="v_tip">
            <div
              v-tip="((item.province||'')+(item.city||'')+(item.companyAddress||''))||'--'"
              class="content"
            ></div>
          </div>
          <div>{{item.phoneNumber||'--'}}</div>
          <div v-if="item.memberLevel">{{ item.memberLevel | Level}}</div>
          <div v-else>--</div>
          <div>{{ item.authorizedTime ||'--'}}</div>
          <div>{{ item.authorizedTime ||'--'}}</div>
          <div>{{item.registerSource=='1'?'官网':'其他'||'--'}}</div>
          <div>{{item.saleName ||'--'}}</div>
          <div v-if="item.saleName" @click="changesale(item)" class="font-btn normal">更改客户经理</div>
          <div v-else @click="changesale(item)" class="font-btn normal">分配客户经理</div>
        </div>
        <div style="text-align: center" v-if="data_list.length<=0" class="list-item">暂无数据</div>
      </div>
    </div>
    <z-windowPop
      v-model="popshow"
      width="360px"
      :black="true"
      :noBtns="true"
      top="50%"
      title="账号信息"
    >
      <div class="popmain">
        <div v-for="(item,value, index) in now_dataF" :key="index" class="popitem">
          <div class="dataitemTitle">{{cc[index]}}：</div>
          <div class="dataitemValue">{{item}}</div>
        </div>
      </div>
    </z-windowPop>

    <z-windowPop
      v-model="salechange"
      width="454px"
      height="280px"
      @confirm="$func.shake(salefunc)"
      :black="true"
      :btnshow="true"
      top="50%"
      title="分配/更改客户经理"
    >
      <div class="popmain">
        <span>客户经理：</span>
        <el-select size="mini" v-model="sale_data" slot="prepend" placeholder="请选择">
          <el-option
            v-for="(item, index) in sale_data_list"
            :key="index"
            :label="item.saleName"
            :value="item.saleName"
          ></el-option>
        </el-select>
      </div>
      <div class="popmain">
        <span>生效时间：</span>
        <el-date-picker
          class="datepicker"
          v-model="open_time"
          size="mini"
          type="date"
          value-format="timestamp"
          :picker-options="pickerOptions"
          placeholder="选择日期"
        ></el-date-picker>
        <span class="tip">(设置生效时间只会影响该时间其后的订单数据的客户经理)</span>
      </div>
    </z-windowPop>

    <z-pagination
      @sizeChange="getData()"
      @pageChange="handleCurrentChange"
      :current-page.sync="now_page"
      :page-size="10"
      :total="total"
    ></z-pagination>
  </z-page>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        // 时间限制
        disabledDate(time) {
          let end_time = new Date();
          end_time.setDate(1);
          end_time.setHours(0);
          end_time.setSeconds(0);
          end_time.setMinutes(0);
          return (
            time.getTime() > Date.now() || time.getTime() < end_time - 10000000
          );
        }
      },
      searchPickerOptions: {
        // 时间限制
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      salechange: false, //更改经理POP提示
      loading: false,
      popshow: false,
      sale_data: "", //修改经理  经理容器
      sale_user: "", //修改经理  客户容器
      sale_data_list: [],
      open_time: "", //生效时间
      now_page: 1,
      total: 1,
      product: [],
      cc: [
        "账号",
        "公司全称",
        "所在地区",
        "会员等级",
        "注册时间",
        "老优惠价余额",
        "新优惠价余额",
        "专属优惠卷",
        "账户余额",
        "可提现余额"
      ],
      search: {
        text_type: 1,
        member_level: "",
        productId: "",
        registerSource: null
      },
      data_list: [],
      searching: {},
      now_data: {}
    };
  },

  created() {
    // 获得产品并且赋值给弹框
    this.$store.dispatch("getproduct").then(res => {
      if (res[0]) {
        this.searching.productId = res[0].ecsProduct.id;
        this.search.productId = res[0].ecsProduct.id;
        this.search.productId = res[0].ecsProduct.id;
        this.product = res;
        console.log(this.product);
      }

      this.getData();
      this.open_time = new Date();
      this.open_time.setDate(1);
      this.open_time.setHours(0);
      this.open_time.setSeconds(0);
      this.open_time.setMinutes(0);
      this.open_time = this.open_time.getTime();
    });
  },
  methods: {
    // 页数改变行数
    handleCurrentChange(val) {
      this.now_page = val;
      this.getData();
    },
    searchData() {
      this.searching = JSON.parse(JSON.stringify(this.search));
      if (this.search.text_type == 1) {
        this.searching.account = this.search.text;
      } else {
        this.searching.companyName = this.search.text;
      }

      this.handleCurrentChange(1);
    },
    clearsearch() {
      this.searching = {};
      this.search = {
        text_type: 1,
        member_level: "",
        productId: this.product[0].ecsProduct.id,
        registerSource: null
      };
      this.handleCurrentChange(1);
    },
    // 详情页展示
    // showdata(item){
    //     this.popshow=true;
    //     this.now_data=JSON.parse(JSON.stringify(item))
    // },
    //更改客户经理方法
    changesale(val) {
      this.salechange = true;
      this.sale_user = val.id;
      this.sale_data = val.saleName || "";
      let url = `/api/supplier/auth/user/get/sales`;
      this.$http.get(url).then(res => {
        if (res.code == "200") {
          this.sale_data_list = res.res_data;
          console.log(this.sale_data_list);
        }
      });
    },
    //修改
    salefunc() {
      let url = `/api/supplier/auth/user/sale/change`;
      let i;
      this.sale_data_list.map(val => {
        if (this.sale_data == val.saleName) {
          i = val.id;
        }
      });
      this.$http
        .post(
          url,
          {},
          {
            params: {
              id: this.sale_user,
              sale_id: i,
              effect_time: this.$func.myTimeToLocal(this.open_time)
            }
          }
        )
        .then(res => {
          if (res.code == "200") {
            this.successTip("修改成功");
            this.salechange = false;
          } else {
            this.errorTip(res.res_data);
          }
          this.salechange = false;
          this.getData();
        });
    },
    getData(num) {
      this.loading = true;
      let url = `/api/supplier/get/member/list`;

      this.$http
        .get(url, {
          params: {
            product_id: this.searching.productId,
            page: num || this.now_page,
            account: this.searching.account || null,
            company_name: this.searching.companyName,
            member_level: this.searching.member_level || null,
            open_product_time_start:
              this.$func.myTimeToLocal(this.searching.start_time) || null,
            open_product_time_end:
              this.$func.myTimeToLocal(this.searching.end_time) || null,
            register_source: this.searching.registerSource
          }
        })
        .then(res => {
          if (res.code == "200") {
            this.data_list = res.res_data.list;
            this.total = res.res_data.total;
          } else {
            this.errorTip(res.res_data);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    now_dataF() {
      delete this.now_data["MonthC"];
      delete this.now_data["phone"];
      return this.now_data;
    }
  }
};
</script>

<style lang="less" scoped>
.popmain {
  padding-left: 32px;
  position: relative;
  margin: 30px 0 20px 60px;
  span {
    top: 50%;
    left: 0%;
    transform: translate(-50%, -50%);
    position: absolute;
    display: inline-block;
  }
  .tip {
    top: 100%;
    left: -9%;
    transform: translate(0%, 0%);
    position: absolute;
    display: inline-block;
    opacity: 0.6;
  }
  .el-select,
  .datepicker {
    width: 85%;
  }
}
.list-head,
.list-item {
  > div {
    &:nth-child(4),
    &:nth-child(6),
    &:nth-child(5),
    &:nth-child(8),
    &:nth-child(7) {
      text-align: center;
    }
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(6),
    &:nth-child(4),
    &:nth-child(7) {
      width: 12%;
    }
    &:nth-child(1),
    &:nth-child(5),
    &:nth-child(8),
    &:nth-child(9) {
      width: 7%;
    }
  }
}
.list-item {
  > div > span {
    cursor: pointer;
    color: rgba(22, 163, 255, 1);
    &:hover {
      color: rgba(22, 163, 255, 0.6);
    }
    &:active {
      color: rgba(0, 133, 220, 1);
    }
  }
}
</style>
